import { authHeader, handleResponse, forDownload } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getTestDetails(testId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/tests/${testId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function downloadTestFile(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };

  const { testId, fileName } = queryParams;
  const endPoint = `/api/admin/v1/tests/${testId}/attachments/pdf`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(forDownload)
    .then(({ download, url }) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      return download;
    });
}

export const testDetailService = {
  getTestDetails,
  downloadTestFile,
};
